import React, { useState, useMemo } from 'react';
import { Text, TextArea, Select } from '@/../components/Fields'
import transactionStore from '@/../stores/transaction';
import Button from '@/../components/Button'
import DirectionSelector from '@/../components/DirectionSelector'
import Table from '@/../components/Table'
import DestinationSelect from '@/../components/DestinationSelect'
import RegionSelect from '@/../components/RegionSelect'
import CategorySelect from '@/../components/CategorySelect'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro' // <-- import styles to be used
import { produce } from 'immer'
import regionStore from '@/../stores/region'
import locationsStore from '@/../stores/locations'

export default () => {
  const [minimized, setMinimized] = useState(false);
  const [
    transactionToEdit,
    setTransactionToEdit,
    locationId,
    setLocationId,
    save,
    clear,
    errors,
    saving,
  ] = transactionStore(state => [
    state.transactionToEdit,
    state.setTransactionToEdit,
    state.locationId,
    state.setLocationId,
    state.save,
    state.clear,
    state.errors,
    state.saving,
  ]);
  const [regions] = regionStore(state => [state.collection])
  const [
    locations,
    fetchLocations,
  ] = locationsStore((state) => [
    state.collection,
    state.fetch,
  ])

  if ((transactionToEdit?.items_attributes?.length ?? 0) == 0) return null

  return <div className="fixed bottom-0 right-16 shadow-transaction rounded-t-lg max-h-full grid" style={{gridTemplateRows: "auto 1fr auto", maxHeight: "calc(100vh - 1rem)"}}>
    <div className="bg-sky-800 text-white font-bold p-2 rounded-t-lg">
      <div className="flex justify-between items-center gap-6">
        <div>{transactionToEdit.id ? `Edit Transaction #${transactionToEdit.id}` : "New Transaction"}</div>
        <div>
          {minimized
            ? <FontAwesomeIcon icon={icon({name: 'window-maximize'})} className="cursor-pointer" onClick={e => setMinimized(false)} />
            : <FontAwesomeIcon icon={icon({name: 'window-minimize'})} className="cursor-pointer" onClick={e => setMinimized(true)} />
          }
        </div>
      </div>
    </div>
    {!minimized && <>
      <div className="bg-white p-2 border-l border-r overflow-auto">
        {errors?.length > 0 && <div className="mb-4 text-red-500 bg-red-100 p-4 rounded border border-red-200">
          <h3 className="font-bold text-lg mb-2">Oh No!</h3>
          <ul className="list-disc pl-6">
            {errors.map((error, index) => <li key={index}>{error}</li>)}
          </ul>
        </div>}
        {!transactionToEdit.purchase_order_id && <>
          <DirectionSelector label="Transaction Type" groupClass="mb-4" />
          <Select
            onChange={e => setTransactionToEdit({...transactionToEdit, location_id: e.target.value})}
            value={transactionToEdit.location_id}
            label="Source Location"
            groupClass="mb-4"
          >
            <option value="">Select Location</option>
            {locations.map(location => <option key={location.id} value={location.id}>{location.title}</option>)}
          </Select>
        </>}
        {transactionToEdit.direction == -2 && <>
          <Select
            onChange={e => setTransactionToEdit({...transactionToEdit, destination_location_id: e.target.value})}
            value={transactionToEdit.destination_location_id}
            label="Target Location"
            groupClass="mb-4"
          >
            <option value="">Select Location</option>
            {locations.filter(location => location.id != locationId).map(location => <option key={location.id} value={location.id}>{location.title}</option>)}
          </Select>
        </>}
        {transactionToEdit.direction == -1 && <>
          <CategorySelect
            onChange={category => setTransactionToEdit({...transactionToEdit, category: category?.value})}
            value={transactionToEdit.category}
          />
          <Text
            label="Magento Order #"
            value={transactionToEdit.magento_order_id}
            onChange={e => setTransactionToEdit({...transactionToEdit, magento_order_id: e.target.value})}
            groupClass="mb-4"
          />
          <DestinationSelect
            allowDeleteLast
            value={transactionToEdit.destinations_transactions_attributes ?? []}
            onChange={(destinations, lastSelected) => {
              const newTransaction = {
                ...transactionToEdit,
                destinations_transactions_attributes: destinations,
              }
              if (!transactionToEdit.region_id) {
                newTransaction.region_id = regions.find(r => r.uuid == lastSelected?.id_Region)?.value
              }
              setTransactionToEdit(newTransaction)
            }}
          />
          <RegionSelect
            onChange={region => setTransactionToEdit({...transactionToEdit, region_id: region?.value})}
            value={transactionToEdit.region_id}
          />
        </>}  
        {transactionToEdit.direction == 0 && <>
          <div className="flex justify-center gap-4">
            <label className="flex items-center">
              <input
                type="radio"
                name="state"
                value="order"
                checked={transactionToEdit.state == 'order'}
                onChange={e => setTransactionToEdit({...transactionToEdit, state: e.target.value, urgent: false})}
              />
              <span className="ml-2">Order</span>
            </label>
            <label className="flex items-center">
              <input
                type="radio"
                name="state"
                value="request"
                checked={transactionToEdit.state == 'request'}
                onChange={e => setTransactionToEdit({...transactionToEdit, state: e.target.value})}
              />
              <span className="ml-2">Request</span>
            </label>
          </div>
          {transactionToEdit.state == 'request' && <>
            <label className="flex items-center gap-2 mb-4">
              <input
                type="checkbox"
                checked={!!transactionToEdit.urgent}
                onChange={e => setTransactionToEdit({...transactionToEdit, urgent: e.target.checked})}
              />
              <span>Urgent purchase request</span>
            </label>
          </>}
          {transactionToEdit.state != 'request' && <>
            <Text 
              label="PO Number" 
              value={transactionToEdit.po_number} 
              onChange={e => setTransactionToEdit({...transactionToEdit, po_number: e.target.value})}
              groupClass="mb-4"
            />
            <Text 
              label="Expected On" 
              type="date"  
              value={transactionToEdit.expected_on} 
              onChange={e => setTransactionToEdit({...transactionToEdit, expected_on: e.target.value})}
              groupClass="mb-4"
            />
          </>}
          <TextArea
            label="Notes"
            value={transactionToEdit.notes}
            onChange={e => setTransactionToEdit({...transactionToEdit, notes: e.target.value})}
            groupClass="mb-4"
          />
        </>}  
        <Table className="mb-4">
          <Table.Head>
            <Table.Row>
              <Table.Th>SKU</Table.Th>
              {transactionToEdit.direction != 2 &&
                <Table.Th>Returnable</Table.Th>
              }
              <Table.Th>{transactionToEdit.direction == 0 && transactionToEdit.state == 'request' && 'Requested '}Quantity</Table.Th>
              <Table.Th></Table.Th>
            </Table.Row>
          </Table.Head>
          <Table.Body>
            {transactionToEdit.items_attributes.filter(item => !item._destroy).map(item =>
              <Table.Row key={item.product_id}>
                <Table.Td>{item.product.sku}</Table.Td>
                {transactionToEdit.direction != 2 &&
                  <Table.Td className="text-center">
                    <input
                      type="checkbox"
                      checked={item.returnable}
                      onClick={e => setTransactionToEdit(produce(transactionToEdit, draft => {
                        const itemToUpdate = draft.items_attributes.find(i => i.product_id == item.product_id);
                        if (itemToUpdate) {
                          itemToUpdate.returnable = !itemToUpdate.returnable;
                        }
                      }))}
                    />
                  </Table.Td>
                }
                <Table.Td>
                  <input
                    type="number"
                    className="border rounded px-4 py-2"
                    placeholder="Quantity"
                    value={item.quantity}
                    onChange={e => setTransactionToEdit(produce(transactionToEdit, draft => {
                      const itemToUpdate = draft.items_attributes.find(i => i.product_id == item.product_id);
                      if (itemToUpdate) {
                        itemToUpdate.quantity = e.target.value;
                      }
                    }))}
                  />
                </Table.Td>
                <Table.Td>
                  <Button
                    type="danger"
                    tabIndex="-1"
                    onClick={e => setTransactionToEdit(produce(transactionToEdit, draft => {
                      const index = draft.items_attributes.findIndex(i => i.product_id == item.product_id);
                      if (index > -1) {
                        if (draft.items_attributes[index].id) {
                          draft.items_attributes[index]._destroy = true;
                        } else {
                          draft.items_attributes.splice(index, 1);
                        }
                      }
                    }))}
                  >
                    <FontAwesomeIcon icon={icon({name: 'trash'})} />
                  </Button>
                </Table.Td>
              </Table.Row>
            )}
            <Table.Row>
              <Table.Td className="text-right" colspan={transactionToEdit.direction == 2 ? "1" : "2"}>Total:</Table.Td>
              <Table.Td className="text-right" key="total">
                {transactionToEdit.items_attributes.reduce((acc, item) => acc + parseInt(item.quantity), 0)}
              </Table.Td>
              <Table.Td></Table.Td>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
      <div className="bg-white p-2">
        <div className="flex justify-between">
          <Button
            type="danger"
            onClick={clear}
          >
            Cancel
          </Button>
          <Button
            type="success"
            onClick={save}
            disabled={saving}
          >
            {saving && <FontAwesomeIcon icon={icon({name: 'spinner', style: 'solid'})} className="animate-spin mr-2" />}
            {transactionToEdit.id ? 'Update' : 'Create'}
          </Button>
        </div>
      </div>
    </>}
  </div>
}
